/**
 * After in-web cleanup, close embedded native WebView when available (same pattern as other containers).
 * Otherwise navigate to home inside the PWA.
 */
export default function dismissNativeWebViewOrNavigateHome(history) {
  if (typeof window === 'undefined') {
    history.push('/home');
    return;
  }
  if (window.Android !== undefined) {
    window.Android.closeView();
    window.Android.closeView(true);
    return;
  }
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({ method: 'closeView' })
    );
    return;
  }
  if (
    window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers.visitIosView
  ) {
    window.webkit.messageHandlers.visitIosView.postMessage(
      JSON.stringify({ method: 'closeView' })
    );
    return;
  }
  history.push('/home');
}
